module.exports = __webpack_public_path__ + "static/media/spaces-off.2a240978.svg";